export default "__VITE_ASSET__Dbb0P4cW__"